import React, { useEffect, useState } from "react";
import { Table, Spinner, Pagination, Form } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";

const API_URL = process.env.REACT_APP_API_URL;

function MyAssociates() {
  const [mobile, setMobile] = useState("");
  const [associateName, setAssociateName] = useState("");
  const [checking, setChecking] = useState(false);

  const getAuthToken = () => localStorage.getItem("token");

  // ✅ Auto fetch associate name when mobile reaches 10 digits
  useEffect(() => {
    const fetchAssociateName = async () => {
      if (mobile.length === 10) {
        setChecking(true);
        setAssociateName("");

        try {
          const token = getAuthToken();
          if (!token) {
            Swal.fire({
              icon: "error",
              title: "Authentication Error",
              text: "Authentication token not found. Please log in again.",
            });
            setChecking(false);
            return;
          }

          const payload = {
            parentid: mobile,
            type: "associate",
          };

          const response = await fetch(`${API_URL}/check-parentid-name`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
          });

          const data = await response.json();

          if (response.ok && data.status === "1" && data.data?.username) {
            setAssociateName(data.data.username);
          } else {
            setAssociateName("");
          }
        } catch (error) {
          console.error("Error fetching associate name:", error);
          setAssociateName("");
        } finally {
          setChecking(false);
        }
      } else {
        setAssociateName("");
      }
    };

    fetchAssociateName();
  }, [mobile]);

  // const fetchUsers = async () => {
  //   if (!mobile) {
  //     Swal.fire({
  //       icon: "warning",
  //       title: "Missing Input",
  //       text: "Please enter a mobile number",
  //     });
  //     return;
  //   }

  //   try {
  //     const response = await axios.get(
  //       `${API_URL}/myteam-list-lavel11-excel?mobile=${mobile}`,
  //       { responseType: "blob" }
  //     );

  //     const text = await response.data.text();
  //     try {
  //       const json = JSON.parse(text);
  //       if (json.status === "0") {
  //         Swal.fire({
  //           icon: "info",
  //           title: "Sorry!",
  //           text: json.message || "No data found",
  //         });
  //         return;
  //       }
  //     } catch (e) { }

  //     const url = window.URL.createObjectURL(new Blob([response.data]));
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", `myteam_level11_${mobile}.xlsx`);
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //   } catch (error) {
  //     Swal.fire({
  //       icon: "warning",
  //       title: "Warning!",
  //       text: "No data found, please try another.",
  //     });
  //   }
  // };
const fetchUsers = async (e) => {
  // Prevent form submission from refreshing the page
  if (e) e.preventDefault();

  if (!mobile) {
    Swal.fire({
      icon: "warning",
      title: "Missing Input",
      text: "Please enter a mobile number",
    });
    return; // stop execution here
  }

  try {
    const response = await axios.get(
      `${API_URL}/myteam-list-lavel11-excel?mobile=${mobile}`,
      { responseType: "blob" }
    );

    const text = await response.data.text();
    try {
      const json = JSON.parse(text);
      if (json.status === "0") {
        Swal.fire({
          icon: "info",
          title: "Sorry!",
          text: json.message || "No data found",
        });
        return;
      }
    } catch (e) { }

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `My 11 Level Team ${mobile}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    Swal.fire({
      icon: "warning",
      title: "Warning!",
      text: "No data found, please try another.",
    });
  }
};

  // return (
  //   <>
  //     <div className="padding_15">
  //       <div className="row">
  //         <div className="col-md-12">
  //           <div className="card">
  //             <div className="card-header">
  //             <div className="titlepage">
  //               <h3>
  //               Download My 11 Level Team In Excel
  //               </h3>
  //             </div>
  //             </div>
  //             <div className="card-body">
  //               <div className="row">
  //                 <div className="col-md-6 offset-md-3">
  //                   <div className="card">
  //                     <div className="card-body">
  //                       <form  onSubmit={fetchUsers}>
  //                         <div className="mb-3 form-group" id="formEmail">
  //                           <label className="form-label fw-bold">Enter Mobile Number</label>
  //                           <input

  //                             type="text"
  //                             placeholder="Enter Mobile Number"
  //                             value={mobile}
  //                             onChange={(e) => setMobile(e.target.value)}
  //                             maxLength="10"
  //                           />
  //                         </div>
  //                         <div className="text-center">
  //                           {checking && (
  //                             <p style={{ color: "gray", marginBottom: "10px" }}>
  //                               Checking associate name...
  //                             </p>
  //                           )}
  //                           {associateName && (
  //                             <p style={{ color: "green", fontWeight: "bold", marginBottom: "10px" }}>
  //                               Name: {associateName}
  //                             </p>
  //                           )}
  //                         </div>
  //                         <div className="submitbutton">
  //                           <button  type="submit" className="submitbutton_design">
  //                             Download Excel
  //                           </button>
  //                         </div>
  //                       </form>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>




  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>


  //   </>

  // );
return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "30px 24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          {/* 🎯 HEADER CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              padding: "20px 24px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "14px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "24px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              📊
            </div>
            <div style={{ flex: 1 }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                Download My 11 Level Team
              </h1>
              <p
                style={{
                  margin: "2px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                Export your downline team data to Excel
              </p>
            </div>
          </div>

          {/* 🎯 MAIN CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div style={{ padding: "30px" }}>
              <div
                style={{
                  maxWidth: "600px",
                  margin: "0 auto",
                }}
              >
                <form onSubmit={fetchUsers}>
                  <label
                    style={{
                      display: "block",
                      fontSize: "13px",
                      fontWeight: "700",
                      color: "#1e3a5f",
                      marginBottom: "8px",
                    }}
                  >
                    Enter Mobile Number
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Mobile Number"
                    value={mobile}
                    onChange={(e) =>
                      setMobile(e.target.value.replace(/\D/g, "").slice(0, 10))
                    }
                    maxLength="10"
                    style={{
                      width: "100%",
                      padding: "12px 16px",
                      borderRadius: "10px",
                      border: "1.5px solid #e2e8f0",
                      outline: "none",
                      fontSize: "14px",
                      marginBottom: "12px",
                    }}
                  />

                  {checking && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        marginBottom: "12px",
                        color: "#64748b",
                        fontSize: "13px",
                      }}
                    >
                      <span
                        style={{
                          width: "14px",
                          height: "14px",
                          border: "2px solid #cbd5e1",
                          borderTop: "2px solid #2b6cb0",
                          borderRadius: "50%",
                          display: "inline-block",
                          animation: "spin 0.8s linear infinite",
                        }}
                      />
                      Checking associate name...
                    </div>
                  )}

                  {associateName && (
                    <div
                      style={{
                        padding: "10px 14px",
                        borderRadius: "10px",
                        background: "#dcfce7",
                        border: "1.5px solid #86efac",
                        color: "#166534",
                        fontSize: "13px",
                        fontWeight: "600",
                        marginBottom: "12px",
                        textAlign: "center",
                      }}
                    >
                      ✓ Name: {associateName}
                    </div>
                  )}

                  <button
                    type="submit"
                    style={{
                      width: "100%",
                      padding: "13px 42px",
                      borderRadius: "12px",
                      border: "none",
                      background:
                        "linear-gradient(135deg, #1e5799, #2b6cb0)",
                      color: "#ffffff",
                      fontSize: "14.5px",
                      fontWeight: "800",
                      letterSpacing: "0.5px",
                      cursor: "pointer",
                      boxShadow: "0 8px 24px rgba(30, 87, 153, 0.3)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                      marginTop: "8px",
                    }}
                  >
                    📥 Download Excel
                  </button>
                </form>

                {/* Info note */}
                <div
                  style={{
                    marginTop: "24px",
                    padding: "16px",
                    borderRadius: "12px",
                    background: "#eff6ff",
                    border: "1.5px solid #bfdbfe",
                    textAlign: "center",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: "13px",
                      color: "#1e3a5f",
                      fontWeight: "600",
                    }}
                  >
                    💡 Enter any associate's 10-digit mobile number to
                    download their 11-level downline team data as Excel file
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Copyright */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
  
}

export default MyAssociates;
